import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (attendanceRecords) => {
        return instance.post('/api/ipms/attendance-records',attendanceRecords);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/ipms/attendance-records/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/ipms/attendance-records',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/ipms/attendance-records',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    exportExcel: (query)=>{
              return instance.get('/api/ipms/attendance-records/exportExcel',{params:{...query},responseType: 'blob'});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/ipms/attendance-records/${id}`);
    },
  /**
   * 详情
   * @param {*} id
   * @returns
   */
    getMember: (qury) => {
    return instance.post(`/api/ipms/attendance-records/getmember`,qury);
  },
  /**
   * 获取当前用户考勤分组
   */
  getGRoup: ()=>{
      return instance.get('/api/ipms/attendance-records/getGroup')
  },
}
